import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import "./Sidebar.css";

export default function SidebarOrganizer() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">Organizer</div>
      <nav className="sidebar-nav">
        <Link to="/organizer/dashboard">📊 Dashboard</Link>
        <Link to="/organizer/groups">👥 Groups</Link>
        <Link to="/organizer/progress">📈 Progress</Link>
        <Link to="/organizer/spinner">🎡 Spinner</Link>
      </nav>
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
}
